import apiClient from './apiClient';

/**
 * Direct booking engine payment configuration (BookingEngineConfig).
 *
 * Two modes: no upfront payment (guests book and pay at the property) or
 * charge at booking through a gateway. Gateway secrets are write-only —
 * the GET only says whether one is stored, and sending an empty secret
 * keeps the stored value.
 */
const bookingEngineService = {
  getPaymentSettings: () => apiClient.get('/v1/settings/booking-engine-payments'),
  updatePaymentSettings: (data) => apiClient.put('/v1/settings/booking-engine-payments', data),
};

export default bookingEngineService;
